/**
 * Created by portiz on 12/19/2018.
 */
import React from 'react';
import {Card, CardBody, Col, Button, CardHeader, Row, Container, CardTitle} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json";
/** End of Multiple Language imports **/

import LanguageManager from '../../custom-classes/language-manager';
import NavbarMobile from './navbar-employee/navbar-mobile';
import NavbarDesktop from './navbar-employee/navbar-desktop';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHeadset, faExclamationCircle} from '@fortawesome/free-solid-svg-icons';
import Footer from '../footer/footer';
import Chatbox from '../chat/chatbox';
import ApiCalls from '../../custom-classes/api-calls';
import socket from '../../components/chat/socket';
import Sound from 'react-sound';
import Switch from "react-switch";

/**
 * The form to handle the chatroom
 */
class ChatroomEmployee extends React.Component {

    constructor(props) { // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
            chatroomChosen: null,
            chatrooms: null,
            checked: true,
            client: socket()
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);
        this.selectChatRoom = this.selectChatRoom.bind(this);
        this.handleAlertToggle = this.handleAlertToggle.bind(this);
    }

    handleAlertToggle(){
        this.setState({checked: !this.state.checked});
    }

    /**
     * selects the chatroom according to the button valie
     * @param e the event to take the target value
     */
    selectChatRoom(e){
        this.setState({
            chatroomChosen: e.target.value
        });
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.getChatrooms();

        // This is promise
        let apiCall = ApiCalls.getEmployeeFullName();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{
            this.setState({'user': data.UserFullName.GivenName + ' ' + data.UserFullName.Surname},()=>{
                this.state.client.register(this.state.user, true, (err, user)=>{
                    this.setState({'user': user});
                });
            })
        }).then(() =>{
            this.setState({
                options: arrOptions
            });
        });
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /** Returns the chatrooms **/
    getChatrooms(){
        setInterval(()=>{
            let playAudio = false;
            // Constantly call the chatrooms and verify if they have
            // two members, to evaluate if the help is required or not.
            this.state.client.getChatrooms((err,chatrooms)=>{
                this.setState({
                    chatrooms: chatrooms,
                    checked: this.state.checked
                });
            });
        }, 1000)
    }

    /**
     * Returns the chatrooms available
     * @returns {XML}
     */
    renderRoomsList(){

        return(
        <React.Fragment>
            {
                this.state.chatrooms === null || this.state.chatrooms.length === 0 ? null :
                this.state.chatrooms.map(
                    item => (
                    <Card body key={item.name}>
                        {
                            item.numMembers < 2 && this.state.checked ?
                            <Sound
                                url="chat-alert.mp3"
                                playStatus={Sound.status.PLAYING}
                                playFromPosition={300 /* in milliseconds */}
                            /> : null
                        }
                        <CardTitle>
                            {item.numMembers < 2 ?
                                <FontAwesomeIcon className="red-text" icon={faExclamationCircle}  size="2x"/> : null
                            }
                            {' '}{item.name}
                        </CardTitle>
                        <Button value={item.name} onClick={this.selectChatRoom} color="success">
                            <Translate id="chat.help-user" options={{renderInnerHtml: true}}/>
                        </Button>
                    </Card>
                    )
                )
            }
        </React.Fragment>
        );
    }

    /**
     * Renders the main form element
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faHeadset}/>{' '}
                            <Translate id="chat.chatroom" options={{renderInnerHtml: true}}/>
                        </h2>
                        <small className="white-text">
                            <Translate id="chat.chatroom-subtitle" options={{renderInnerHtml: true}}/>
                        </small>
                        <hr/>
                        <Row>
                            <Col  lg={{size: 5}} md={{size:5}} sm={{size:12}} xs={{size:12}}>
                                <Card>
                                    <CardHeader>
                                        <Translate id="chat.select-client" options={{renderInnerHtml: true}}/>
                                        <hr style={{color: '#8e8e8e', borderColor: '#8e8e8e', backgroundColor: '#8e8e8e'}}/>
                                        <small>
                                            <Translate id="chat.alert-instructions" options={{renderInnerHtml: true}}/>
                                            <br/>
                                            <Switch
                                            onChange={this.handleAlertToggle}
                                            checked={this.state.checked}  offColor="#f44256"
                                            id="normal-switch"
                                            />
                                        </small>
                                    </CardHeader>
                                    <CardBody>
                                        <div className="scrollable-card">
                                            {this.renderRoomsList()}
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col  lg={{size: 7}} md={{size:7}} sm={{size:12}} xs={{size:12}}>
                               <Chatbox chatroom={this.state.chatroomChosen} socket={this.state.client}/>
                            </Col>

                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default withLocalize(ChatroomEmployee);